"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeTreeItemStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeTreeItemStyles = function makeTreeItemStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiTreeItem: {
      styleOverrides: {
        root: {
          color: tokens.colors["ink-on-background"].rgb
        },
        content: _objectSpread(_objectSpread({
          width: "unset",
          padding: primitives.spacings["4"],
          position: "relative",
          borderRadius: primitives.borderRadii.medium,
          zIndex: 1
        }, tokens.transitions["state-blur"]), {}, {
          "&:hover": _objectSpread(_objectSpread({}, tokens.gradients["row-highlighted-hover-loud-reverse"]), tokens.transitions["state-activate"]),
          "&.Mui-selected": _objectSpread(_objectSpread({
            background: "none"
          }, tokens.transitions["state-activate"]), {}, {
            "&:hover": _objectSpread(_objectSpread({}, tokens.gradients["row-highlighted-hover-loud-reverse"]), tokens.transitions["state-activate"])
          }),
          "&.Mui-focused": _objectSpread(_objectSpread(_objectSpread({}, tokens.transitions["state-activate"]), tokens.effects["focus-ring-thin"]), {}, {
            background: "none",
            "&:active": _objectSpread({
              boxShadow: "none"
            }, tokens.gradients["row-highlighted-pressed-loud-reverse"])
          }),
          "&.Mui-selected.Mui-focused": {
            background: "none",
            "&:active": _objectSpread({
              boxShadow: "none"
            }, tokens.gradients["row-highlighted-pressed-loud-reverse"])
          },
          "&.Mui-disabled": {
            background: "none"
          },
          "&:active": _objectSpread(_objectSpread({
            boxShadow: "none"
          }, tokens.gradients["row-highlighted-pressed-loud-reverse"]), tokens.transitions["state-activate"])
        }),
        group: {
          margin: "0",
          position: "relative",
          padding: "0",
          "&:before": _objectSpread(_objectSpread({
            content: '""',
            position: "absolute",
            height: "100%",
            width: "100%",
            bottom: 0,
            zIndex: 2
          }, tokens.transitions["state-blur"]), {}, {
            background: "linear-gradient(0deg, ".concat(tokens.colors["fade-gradient-opaque"].rgb, " 0%, ").concat(tokens.colors["fade-gradient-transparent"].rgb, " 100%)")
          }),
          '&[class*="MuiCollapse-entered"]:before': {
            height: "0%"
          },
          '& [class*="MuiTreeItem-root"]': {
            marginLeft: primitives.spacings["4"]
          }
        },
        label: {
          paddingRight: primitives.spacings["4"]
        }
      }
    }
  };
};

exports.makeTreeItemStyles = makeTreeItemStyles;